import { gql } from '@apollo/client'

const DELETE_LAB_RESULT = gql`
  mutation deleteLabResult($id: ID!) {
    deleteLabResult(id: $id) {
      success
    }
  }
`

export default DELETE_LAB_RESULT
